import { useLocalSelector } from '@app/services/hooks/useRedux';

import { ALL_TAB, MODULE_TABS, OrdersTab } from '../interfaces';

export const useOrdersTabs = () => {
  // Модули, по которым организация участвует в коалициях, отдаёт сервис заказов
  const modules: string[] =
    useLocalSelector((state) => state.currentSession.ordersContext?.scope?.counterparty_modules) || [];
  const tabs: OrdersTab[] = [ALL_TAB, ...MODULE_TABS.filter((module) => modules.includes(module))];

  return { tabs };
};
